import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CookiesConsentService } from '@ildes/services/cookies-consent.service';
import { ToastService } from '@ildes/services/toast.service';


@Component({
  selector: 'app-confirm-cookies',
  standalone: true,
  imports: [ MatButtonModule, RouterModule],
  template: `
  <p>Usamos cookies y datos para proporcionar y mantener nuestros servicios. Para ello es necesario usar reCAPTCHA v3, que incluye cookies de analítica y seguridad ante bots y fraudes.</p>
  <p>Si eliges Aceptar todo, también usaremos cookies y datos para detectar errores y poder mejorar la experiencia.</p>
  <p>Accede a nuestra <a [routerLink]="['/policies/cookies']">Política de cookies y datos</a> para más detalle.</p>
  <button (click)="acceptEssentials()" mat-raised-button class="margin-right-8">Usar sólo esenciales</button>
  <button (click)="accept()" mat-raised-button color="primary">Aceptar todo</button>
  `,
  styleUrls: ['./confirm-cookies.component.css'],
})
export class ConfirmCookiesComponent {

   constructor(
    private cookiesConsent: CookiesConsentService,
    private toastService: ToastService,
   ) {
        this.toastService.setCookiesOpened(true);
   }
    acceptEssentials() {
        this.toastService.setCookiesOpened(false);
        this.cookiesConsent.setCookiesConsentData({errors: false})

        window.location.reload();
    }

    accept() {
        this.toastService.setCookiesOpened(false);
         this.cookiesConsent.setCookiesConsentData({errors: true})

        window.location.reload();
    }
}
